var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-box"},[_c('div',{staticClass:"title"},[_vm._v("文件列表(按照日报编号-文件名称的方式，一行一个)")]),_c('el-input',{attrs:{"type":"textarea","rows":8,"placeholder":"请输入"},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }